(function () {
  "use strict";

  function convertStringToSeconds(time) {
    if (!time) {
      return null;
    }

    const parts = time.split(":");

    if (parts.length !== 3) {
      return null;
    }

    const hours = parseInt(parts[0]);

    if (isNaN(hours) || hours < 0 || hours >= 24) {
      return null;
    }

    const minutes = parseInt(parts[1]);

    if (isNaN(minutes) || minutes < 0 || minutes >= 60) {
      return null;
    }

    const seconds = parseInt(parts[2]);

    if (isNaN(seconds) || seconds < 0 || seconds >= 60) {
      return null;
    }

    return hours * 3600 + minutes * 60 + seconds;
  }

  class Bar {
    constructor(rootElement) {
      this.root = rootElement;

      const changeBackground = this.root.dataset.announcementBarChangeBackground;

      if (changeBackground !== "true") {
        return;
      }

      const changeBackgroundBegin = this.root.dataset.announcementBarChangeBackgroundBegin;
      this.begin = convertStringToSeconds(changeBackgroundBegin);

      const changeBackgroundEnd = this.root.dataset.announcementBarChangeBackgroundEnd;
      this.end = convertStringToSeconds(changeBackgroundEnd);

      if (this.begin !== null && this.end !== null) {
        this.update();
      }
    }

    update() {
      const now = new Date();
      const nowInSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

      if (nowInSeconds < this.begin) {
        this.root.style.setProperty("--background", "100 174 136");
        setTimeout(this.update.bind(this), (this.begin - nowInSeconds) * 1000);
      } else if (nowInSeconds < this.end) {
        this.root.style.setProperty("--background", "227 0 0");
        setTimeout(this.update.bind(this), (this.end - nowInSeconds) * 1000);
      } else {
        this.root.style.setProperty("--background", "100 174 136");
        setTimeout(this.update.bind(this), (24 * 3600 - nowInSeconds) * 1000);
      }
    }
  }

  function run() {
    for (const bar of document.querySelectorAll(".announcement-bar")) {
      bar.bar = new Bar(bar);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

})();
